export default __webpack_public_path__ + "static/media/brand-icons.278156e4.woff2";